module.exports = __webpack_public_path__ + "media/images/background-a2bf4b7ee5abef68c812dbb873163719.jpg";